import { ADD_CONDITIONAL_DISPLAY_TOPICS } from "../../../../constants";

export const addDisplayConditionBlockBasedOnHris = (payload, cb) => {
    return (dispatch) => {
        dispatch({ type: ADD_CONDITIONAL_DISPLAY_TOPICS, payload });
    }
};